import service from '../services/purchasesPayments.service';

export const purchasesPayments = {
    namespaced: true,
    state: {
        data: [],
        currentPage: 1,
        lastPage: 1,
        links: [],
        getData: [],
    },
    getters: {
        allData: (state) => state.data,
        pagination: (state) => ({
            currentPage: state.currentPage,
            lastPage: state.lastPage,
        }),
        links: (state) => state.links,
        getData: (state) => state.getData,
    },
    actions: {
        async fetchData({ commit }, data = null) {
            try {
                const response = await service.getAll(data);
                commit('SET_DATA', response.data.data);
                commit('SET_PAGINATION', {
                    currentPage: response.data.current_page,
                    lastPage: response.data.last_page,
                    links: response.data.links,
                });
            } catch (error) {
                console.error('Error fetching purchase payments:', error);
            }
        },
        async save(context, data) {
            try {
                let response;
                if (data.id == 0) {
                    response = await service.createData(data);
                } else {
                    response = await service.updateData(data.id, data);
                }
                return response;
            } catch (error) {
                console.error('Error save purchase payment:', error);
                return error.response;
            }
        },
        async delete(context, paymentId) {
            try {
                const response = await service.deleteData(paymentId);
                return response;
            } catch (error) {
                throw error.response;
            }
        },
        async getData(context, id) {
            try {
                const response = await service.getData(id);
                return response;
            } catch (error) {
                console.error('Error fetching purchase payments:', error);
                throw error.response;
            }
        },
    },
    mutations: {
        SET_DATA(state, data) {
            state.data = data;
        },
        SET_PAGINATION(state, pagination) {
            state.currentPage = pagination.currentPage;
            state.lastPage = pagination.lastPage;
            state.links = pagination.links;
        },
        SET_GET_DATA(state, data) {
            state.getData = data;
        },
    },
};
